import { useLayoutEffect, useState } from 'react';

export default function useLockBody() {
  // set states
  const [overflow, setOverflow] = useState(null);
  const [position, setPosition] = useState(null);
  const [width, setWidth] = useState(null);

  // lock body effect
  useLayoutEffect(() => {
    // check if browser
    if (!(typeof window !== 'undefined')) return null;

    // get current body values
    const currOverflow = window.getComputedStyle(document.body).overflow;
    const currPosition = window.getComputedStyle(document.body).position;
    const currWidth = window.getComputedStyle(document.body).width;

    // set current values to states
    setOverflow(currOverflow);
    setPosition(currPosition);
    setWidth(currWidth);

    // set body position to fixed
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';

    return () => {
      // reset body position to previous values
      document.body.style.position = position;
      document.body.style.width = width;
      document.body.style.overflowY = overflow;
    };
  }, []);
}
